<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'configuracion' }">{{ $t("configuracion") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'operarios', params: { idBusiness: idBusiness } }">
                                {{ $t("operarios") }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{ action }} {{ $t("operario") }}</li>
                    </ol>
                </nav>
            </div>
            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-12">
                            <h2 class="tituloNumier"><i class="fa fa-building"></i> {{ nombreNegocio }}</h2>
                            <hr>
                        </div>

                        <!-- Nombre -->
                        <div class="col-md-8">
                            <div class="form-group">
                                <label for="nameCasa"><strong>{{ $t('nombreOperario') }} <span
                                            style="color: red">*</span></strong></label>
                                <input autocomplete="off" type="text" class="form-control"
                                       :class="{
                                           'is-valid': operario.name.length > 0 && operario.name.length <= maxNameOperario,
                                           'is-invalid': operario.name.length > maxNameOperario
                                       }"
                                       id="nameCasa"
                                       v-bind:placeholder="$t('introduzcaNombre')"
                                       v-model="operario.name"
                                       ref="name">
                                <input autocomplete="off" type="hidden" v-model="operario.xname">
                                <small class="form-text text-muted">{{ operario.name.length }}/50</small>
                            </div>
                        </div>

                        <!-- Apellidos -->
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="apellido"><strong>{{ $t('apellidos') }}</strong></label>
                                <input autocomplete="off" type="text" class="form-control" id="apellido"
                                       v-bind:placeholder="$t('introduzcaApellido')" v-model="operario.surName">
                            </div>
                        </div>

                        <!-- Clave acceso -->
                        <div class="col-md-4" style="padding: 0; margin: 0 auto;">
                            <div class="form-group col-md-12" style="padding: 0; margin :0;">
                                <div class="col-md-12">
                                    <label for="pass"><strong>{{ $t('claveAcceso') }}</strong></label>
                                </div>
                                <div style="display: flex; align-items: center; justify-content: space-between;">
                                    <form autocomplete="off" class="col-md-8">
                                        <input autocomplete="off" type="password" class="form-control"
                                               :disabled="!editarPass && idOperario"
                                               id="pass"
                                               v-bind:placeholder="$t('introduzcaPass')"
                                               v-model="operario.password">
                                    </form>
                                    <div class="col-md-4">
                                        <button class="btn btn-primary"
                                                v-if="idOperario"
                                                @click="editarPass = true; operario.password = ''"
                                                icon="el-icon-edit"
                                                circle>
                                            Resetear clave
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Código barras / DNI -->
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="codigoBarras">
                                    <strong>{{ $t("codigoIdentificacion") }} (DNI)
                                        <span style="color: red">*</span>
                                    </strong>
                                </label>
                                <input autocomplete="off" type="text" class="form-control" id="codigoBarras"
                                       v-bind:placeholder="$t('introduzcaCodigoDeBarras')"
                                       v-model="operario.barCode">
                            </div>
                        </div>

                        <!-- Dirección -->
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="direccion"><strong>{{ $t("direccion") }}</strong></label>
                                <input autocomplete="off" type="text" class="form-control" id="direccion"
                                       v-bind:placeholder="$t('introduzcaDireccion')" v-model="operario.address">
                            </div>
                        </div>

                        <!-- Ciudad -->
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="ciudad"><strong>{{ $t("ciudad") }}</strong></label>
                                <input autocomplete="off" type="text" class="form-control" id="ciudad"
                                       v-bind:placeholder="$t('introduzcaCiudad')" v-model="operario.city">
                            </div>
                        </div>

                        <!-- Provincia -->
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="provincia"><strong>{{ $t("provincia") }}</strong></label>
                                <input autocomplete="off" type="text" class="form-control" id="provincia"
                                       v-bind:placeholder="$t('introduzcaProvincia')" v-model="operario.province">
                            </div>
                        </div>

                        <!-- CP -->
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="cp"><strong>{{ $t("codigoPostal") }}</strong></label>
                                <input autocomplete="off" type="text" class="form-control" id="cp"
                                       v-bind:placeholder="$t('introduzcaCodigoPostal')" v-model="operario.cp">
                            </div>
                        </div>

                        <!-- Teléfono -->
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="phone"><strong>{{ $t("telefono") }}</strong></label>
                                <input autocomplete="off" type="text" class="form-control" id="phone"
                                       v-bind:placeholder="$t('introduzcaTelefono')" v-model="operario.phone">
                            </div>
                        </div>

                        <!-- Email -->
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="email"><strong>{{ $t("email") }}</strong></label>
                                <input autocomplete="off" type="text" class="form-control" id="email"
                                       v-bind:placeholder="$t('introduzcaEmail')" v-model="operario.email">
                            </div>
                        </div>

                        <!-- Sueldo -->
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="salario"><strong>{{ $t('sueldo') }}</strong></label>
                                <vue-numeric currency="€" id="salario" inputmode="decimal" type="text"
                                             class="form-control"
                                             currency-symbol-position="suffix"
                                             :precision="2"
                                             v-model="operario.salary"
                                             @keydown.native="$methods.evitarComasDecimales">
                                </vue-numeric>
                            </div>
                        </div>

                        <!-- Código turnos -->
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="passTurno"><strong>{{ $t('codigoDeTurnos') }}</strong></label>
                                <input autocomplete="off" type="text" class="form-control" id="passTurno"
                                       v-bind:placeholder="$t('introduzcapassTurn')" v-model="operario.turnpass">
                            </div>
                        </div>

                        <!-- Clave PDA -->
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="passPda"><strong>{{ $t('claveAccesoPDA') }}</strong></label>
                                <input autocomplete="off" type="text" class="form-control" id="passPda"
                                       placeholder="Contraseña PDA" v-model="operario.turnPda">
                            </div>
                        </div>

                        <!-- Tipo rol (NUEVO) -->
                        <div class="col-md-4" v-if="hasTurnosConfig">
                            <div class="form-group">
                                <label for="rolType"><strong>{{ $t('tipoRol') }}</strong></label>
                                <span style="font-size: x-small">
                                {{ $t("configuracionRol") }}</span>
                                <select id="rolType"
                                        class="form-control"
                                        v-model.number="operario.rolType">
                                    <option :value="0">{{ $t('normal') }}</option>
                                    <option :value="1">{{ $t('encargado') }}</option>
                                </select>
                            </div>
                        </div>

                        <!-- Género -->
                        <div class="col-md-12">
                            <div class="form-group">
                                <div class="form-group">
                                    <label>
                                        <strong>{{ $t("hombre") }}</strong>
                                    </label>
                                    <el-switch v-model="operario.gener"
                                               active-color="#FC6590"
                                               inactive-color="#30A6F3">
                                    </el-switch>
                                    <label>
                                        <strong>{{ $t("mujer") }}</strong>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!-- Baja -->
                        <div class="col-md-12">
                            <div class="form-group">
                                <div class="form-group">
                                    <label>
                                        <strong>{{ $t("baja") }}</strong>
                                    </label>
                                    <el-switch v-model="operario.baja"
                                               active-color="#13ce66"
                                               inactive-color="#bcbcbc">
                                    </el-switch>
                                </div>
                            </div>
                        </div>

                        <!-- Repartidor -->
                        <div class="col-md-12">
                            <div class="form-group">
                                <div class="form-group">
                                    <label>
                                        <strong>{{ $t("repartidor") }}</strong>
                                    </label>
                                    <el-switch v-model="operario.repartidor"
                                               active-color="#13ce66"
                                               inactive-color="#bcbcbc">
                                    </el-switch>
                                </div>
                            </div>
                        </div>

                        <!-- No mostrar en ventas -->
                        <div class="col-md-12">
                            <div class="form-group">
                                <div class="form-group">
                                    <label>
                                        <strong>{{ $t("noMostrarEnVentas") }}</strong>
                                    </label>
                                    <el-switch v-model="operario.mostrarVentas"
                                               active-color="#13ce66"
                                               inactive-color="#bcbcbc">
                                    </el-switch>
                                </div>
                            </div>
                        </div>

                        <!-- Botón restricciones -->
                        <div class="col-md-12"
                             v-if="compareVersions(operario.tpvVersion, '6.3.4.5') >= 0">
                            <button class="btn btn-primary"
                                    @click="showModalPermisos()"
                                    :disabled="inProgress">
                                Restricciones
                            </button>
                        </div>

                        <!-- Guardar / cancelar / replicar -->
                        <div class="col-md-12 pt-2">
                            <button class="btn btn-primary"
                                    v-once-click.once="saveOperario"
                                    :disabled="inProgress">
                                <i class="fa fa-check-square"></i> {{ $t("guardar") }}
                            </button>

                            <router-link :to="{ name: 'operarios', params: { idBusiness: idBusiness, 'pag': pag } }">
                                <button class="btn btn-danger">
                                    <i class="fa fa-window-close"></i> {{ $t("cancelar") }}
                                </button>
                            </router-link>

                            <el-checkbox v-model="checkReply" border class="checkbox-element">
                                {{ $t("replicar") }}
                            </el-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal permisos -->
        <modal name="showPermisos"
               :adaptive="true"
               :scrollable="true"
               height="auto"
               :clickToClose="true"
               :width="getWidthModal">
            <div>
                <h4 style=" margin-left: 20px; margin-bottom: 0px">
                    Restricciones del operario
                </h4>
                <p style="font-size: 10pt; margin-left: 20px; color: gray; margin-bottom: 10px;">
                    Marque las acciones que el operario no puede realizar
                </p>

                <div v-if="screen.width > 992" class="modal-body">
                    <b-form-group>
                        <template #label>
                            <b-form-checkbox style="margin-left: 9px;"
                                             aria-describedby="listPermisosOperario"
                                             aria-controls="listPermisosOperario"
                                             @change="selectAllPermisos()">
                                {{ checkSelectAll ? 'Quitar selección' : 'Seleccionar todos' }}
                            </b-form-checkbox>
                        </template>

                        <div class="permisos-grid">
                            <b-form-checkbox v-model="permiso.checked"
                                             v-for="permiso in listPermisosOperario"
                                             :key="permiso.id">
                                {{ permiso.name }}
                            </b-form-checkbox>
                        </div>
                    </b-form-group>
                </div>

                <div v-else class="modal-body">
                    {{ screen.width }}
                    <b-form-group>
                        <template #label>
                            <b-form-checkbox style="margin-left: 9px;"
                                             aria-describedby="listPermisosOperario"
                                             aria-controls="listPermisosOperario"
                                             @change="selectAllPermisos()">
                                {{ checkSelectAll ? 'Quitar selección' : 'Seleccionar todos' }}
                            </b-form-checkbox>
                        </template>

                        <div>
                            <b-form-checkbox v-model="permiso.checked"
                                             v-for="permiso in listPermisosOperario"
                                             :key="permiso.id">
                                {{ permiso.name }}
                            </b-form-checkbox>
                        </div>
                    </b-form-group>
                </div>
            </div>
        </modal>

        <!-- Modal replicar -->
        <modal name="modalReply"
               :adaptive="true"
               :scrollable="true"
               height="auto"
               :clickToClose="false">
            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">{{ $t("replicarOperario") }}</h4>
                </div>
                <div class="modal-body">
                    <input type="checkbox"
                           id="checkSelectAll"
                           name="checkSelectAll"
                           v-model="checkSelectAll"
                           @click="selectAll">
                    <label for="checkSelectAll" class="checkSelectAll">
                        {{ $t("seleccionarTodos") }}
                    </label>

                    <div v-for="business in listBusinesses">
                        <el-checkbox v-if="business.id != idBusiness"
                                     v-model="business.checked"
                                     border
                                     class="checkbox-element"
                                     style="width: 100%">
                            {{ business.establishmentName }}
                        </el-checkbox>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-default" @click="closeModal()">
                        <i class="fa fa-times-circle"></i>
                        {{ $t("cancelar") }}
                    </button>
                    <button class="btn btn-primary" @click="replyOperario">
                        <i class="fa fa-check-circle"></i>
                        {{ $t("aceptar") }}
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import swal from 'sweetalert2'
import { Checkbox, Switch, Button } from 'element-ui'
import { Loading } from 'element-ui';

export default {
    props: ['idBusiness', 'idOperario', 'pag'],

    created() {
        this.action = this.idOperario ? this.$i18n.t("editar") : this.$i18n.t("nuevo");

        this.loadingGeneral = Loading.service({ text: this.$t('cargando') });

        this.identificacionNegocio();
        if (this.idOperario) {
            this.getOperario();
        } else {
            this.loadingGeneral.close();
        }
        this.screen.width = screen.width;
        this.screen.height = screen.height;
    },

    components: {
        [Checkbox.name]: Checkbox,
        [Switch.name]: Switch,
        [Button.name]: Button
    },

    mounted() {
        this.$refs.name && this.$refs.name.focus();
    },

    data() {
        return {
            myWidth: '70%',
            loadingGeneral: null,
            operario: {
                xname: "",
                name: "",
                password: "",
                barCode: "",
                surName: "",
                address: "",
                cp: "",
                city: "",
                province: "",
                phone: "",
                email: "",
                salary: "",
                turnpass: "",
                turnPda: "",
                gener: false,
                baja: false,
                repartidor: false,
                mostrarVentas: false,
                tpvVersion: "",

                rolType: 0
            },
            checkSelectAll: false,
            checkSelectAllPermisos: false,
            listBusinesses: [],
            listPermisosOperario: [],
            listPermisosOperarioInitial: [],
            checkReply: false,
            maxNameOperario: 50,
            action: "",
            inProgress: false,
            nombreNegocio: "",
            editarPass: false,
            hasTurnosConfig: false,
            screen: {
                width: "",
                height: "",
            },
        }
    },

    methods: {
        identificacionNegocio() {
            const config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios
                .get(this.$store.getters.apiUrl + 'general/getBusinessesByUser', config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.listBusinesses = response.data.result;

                        const currentBusiness = vm.listBusinesses.find(
                            b => b.id === vm.idBusiness
                        );

                        if (currentBusiness) {
                            vm.nombreNegocio = currentBusiness.establishmentName;

                            // ✅ ahora “turnos” significa lo mismo que en el listado
                            vm.hasTurnosConfig = currentBusiness.hash == "1";
                        } else {
                            vm.nombreNegocio = '';
                            vm.hasTurnosConfig = false;
                        }
                    } else {
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },


        checkCampos() {
            if (this.operario.name.length > this.maxNameOperario) {
                swal({
                    title: this.$t('atencion'),
                    text: this.$t('laLongitudDelNombreNoPuedeSerMayorDe') + this.maxNameOperario + '.',
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });
                return false;
            } else if (
                this.operario.name === null ||
                this.operario.name === '' ||
                this.operario.name.length === 0 ||
                this.operario.barCode === ""
            ) {
                swal({
                    title: this.$t('atencion'),
                    text: this.$t('relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar'),
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });
                return false;
            } else {
                return true;
            }
        },

        getOperario() {
            const config = {
                params: {
                    idBusiness: this.idBusiness,
                    idOperario: this.idOperario,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios
                .get(this.$store.getters.apiUrl + 'workers/getWorkerById', config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.operario = response.data.result;
                        vm.operario.xname = response.data.result.name;
                        vm.listPermisosOperario = response.data.result.permisos;
                        vm.listPermisosOperarioInitial = JSON.parse(JSON.stringify(vm.listPermisosOperario));

                        // Si el operario antiguo no trae rolType, ponemos empleado por defecto
                        if (typeof vm.operario.rolType === 'undefined' || vm.operario.rolType === null) {
                        vm.operario.rolType = 0; // solo para antiguos sin dato
                        }

                        vm.loadingGeneral.close();
                    } else {
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }
                });
        },

        saveOperario() {
            if (this.checkCampos()) {
                this.inProgress = true;

                let permisos = [];
                this.listPermisosOperario.forEach(permiso => {
                    if (permiso.checked) {
                        permisos.push(permiso);
                    }
                });

                const config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
                };

                const params = {
                    idBusiness: this.idBusiness,
                    operario: this.operario,
                    jwt: this.$store.getters.jwt,
                    editarPass: this.editarPass,
                    permisos: permisos
                };

                let vm = this;
                let controller = this.idOperario ? "editWorkerById" : "newWorkerByBusiness";

                this.axios
                    .post(this.$store.getters.apiUrl + 'workers/' + controller, params, config)
                    .then(function (response) {
                        vm.inProgress = false;

                        if (response.data.response) {
                            let notify = vm.idOperario ? vm.$t('actualizado') : vm.$t('creado');
                            vm.$notify({
                                message: vm.$t('operario') + ' ' + notify + ' ' + vm.$t('correctamente'),
                                icon: 'nc-icon nc-check-2',
                                timeout: 2000,
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'success'
                            });

                            if (vm.checkReply) {
                                if (!vm.idOperario) {
                                    vm.operario.xname = vm.operario.name;
                                }

                                vm.axios
                                    .get(vm.$store.getters.apiUrl + 'general/getBusinessesByUserReplicado', config)
                                    .then(function (response) {
                                        if (response.data.response) {
                                            vm.listBusinesses = response.data.result;
                                            vm.$modal.show('modalReply');
                                        } else {
                                            swal({
                                                title: vm.$t('atencion'),
                                                text: response.data.message,
                                                confirmButtonClass: 'btn btn-info btn-fill',
                                                type: 'error'
                                            });
                                        }
                                    });

                            } else {
                                vm.$router.push({
                                    name: 'operarios',
                                    params: { idBusiness: vm.idBusiness, 'pag': vm.pag }
                                });
                            }

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });
            }
        },

        replyOperario() {
            const config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let permisos = [];
            this.listPermisosOperario.forEach(permiso => {
                if (permiso.checked) {
                    permisos.push(permiso);
                }
            });

            let vm = this;
            let xbusinesses = [];
            this.listBusinesses.forEach(function (business) {
                if (business.checked && business.id !== vm.idBusiness) {
                    xbusinesses.push(business);
                }
            });

            const params = {
                listBusinesses: xbusinesses,
                operario: this.operario,
                isAfterCreate: this.idOperario === 0 ? 1 : 0,
                jwt: this.$store.getters.jwt,
                editarPass: this.editarPass,
                reply: 1,
                permisos: permisos
            };

            this.axios
                .post(this.$store.getters.apiUrl + 'workers/replyWorker', params, config)
                .then(function (response) {
                    vm.inProgress = false;

                    if (response.data.response) {
                        vm.closeModal();
                    } else {
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    vm.inProgress = false;
                });
        },

        getUpdatedPermisos() {
            let permisos = [];

            this.listPermisosOperario.forEach(permiso => {
                if (permiso.checked) {
                    permisos.push(permiso);
                }
            });

            return permisos;
        },

        closeModal() {
            this.$modal.hide('modalReply');
            this.$router.push({
                name: 'operarios',
                params: { idBusiness: this.idBusiness, 'pag': this.pag }
            });
        },

        showModalPermisos() {
            this.$modal.show('showPermisos');
        },

        hideModalPermisos() {
            this.$modal.hide('showPermisos');
            this.listPermisosOperario = this.listPermisosOperarioInitial;
        },

        acceptPermisos() {
            this.$modal.hide('showPermisos');
        },

        selectAll() {
            if (this.checkSelectAll) {
                this.listBusinesses.forEach(function (business) {
                    business.checked = false;
                });
            } else {
                this.listBusinesses.forEach(function (business) {
                    business.checked = true;
                });
            }
        },

        selectAllPermisos() {
            if (this.checkSelectAllPermisos) {
                this.listPermisosOperario.forEach(function (permiso) {
                    permiso.checked = false;
                });
                this.checkSelectAllPermisos = false;
            } else {
                this.listPermisosOperario.forEach(function (permiso) {
                    permiso.checked = true;
                });
                this.checkSelectAllPermisos = true;
            }
        },

        compareVersions(v1, v2) {
            const v1Parts = (v1 || '').split('.').map(Number);
            const v2Parts = (v2 || '').split('.').map(Number);

            for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
                const v1Part = v1Parts[i] || 0;
                const v2Part = v2Parts[i] || 0;

                if (v1Part > v2Part) {
                    return 1;
                }
                if (v1Part < v2Part) {
                    return -1;
                }
            }
            return 0;
        }
    },

    computed: {
        getWidthModal() {
            let defaultWidth = 60;
            if (screen.width < 992) {
                defaultWidth = 90;
            }
            return `${defaultWidth}%`;
        },
    }
}
</script>

<style scoped>
.card {
    padding: 20px;
}

.permisos-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 1px;
}

.permiso-item {
    display: flex;
    align-items: center;
    border: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Widgets/Operarios/OperarioForm.vue